module.exports = __webpack_public_path__ + "r-v3/img/ico_block_member_white.08235265.svg";